<template>
  <b-card class="cardStyle" no-body style="background: #FDFFF3">
    <section class="cardBody">
      <b-row class="justify-content-between text-center">
        <b-col class="d-flex align-items-center my-3" xl="auto" lg="12" md="12" sm="12" cols="12">
          <div class="detailsText" style="display: flex; align-items: center;">
            <b-icon icon="card-text" scale="1.0" style="margin-right: 10px;"></b-icon>
            Temperature Excursion Forms
          </div> </b-col
        ><b-col
          class="d-flex align-items-center description my-3"
          xl="auto"
          lg="12"
          md="12"
          sm="12"
          cols="12"
          >Use these forms to submit shipment and storage temperature excursions for Pfizer
          Studies</b-col
        >
        <b-col class="d-flex align-items-center my-3" xl="auto" lg="12" md="12" sm="12" cols="12">
          <b-button variant="link" @click="redirectToForms()" size="sm" class="pt-0 buttonText">
            Open Forms
            <b-icon icon="chevron-right" scale="1.0"></b-icon>
          </b-button>
        </b-col>
      </b-row>
    </section>
  </b-card>
</template>

<script>
  import actionArrow from '../../../../images/actionArrow.png';
  export default {
    data() {
      return {
        actionArrow: actionArrow,
      };
    },
    computed: {
      isEnrollmentOversight() {
        return this.$route.name.includes('oversight');
      },
    },
    methods: {
      redirectToForms() {
        this.$router.push({
          name: 'forms',
        });
      },
    },
  };
</script>

<style scoped>
  .detailsText {
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0;
    color: #0060aa;
  }

  .description {
    color: var(--neutrals-neutral, #6f6f6f);
    font-size: 15px;
    line-height: 14px;
    letter-spacing: 0.5px;
  }

  .buttonText {
    color: var(--primary-primary-mid, #585df3);
    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: 0.25px;
  }

  .cardBody {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 0rem 1.5rem;
  }
</style>
